import { formatNumber, formatPercent, formatRial, nodeLabel } from './chainFormat';

function PayoutTable({ rows, buyer = false }) {
    if (rows.length === 0) return null;

    return (
        <div className="chain-detail-table-wrap">
            <table className="chain-detail-table" dir="rtl">
                <thead>
                    <tr>
                        <th>{buyer ? 'معرف بالاسری' : 'خریدار پایین‌دستی'}</th>
                        <th>سطح</th>
                        <th>درصد</th>
                        <th>مبلغ</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={`${row.level}-${buyer ? row.nodeIndex : row.buyerIndex}`}>
                            <td>گره {nodeLabel(buyer ? row.nodeIndex : row.buyerIndex)}</td>
                            <td>{formatNumber(row.level)}</td>
                            <td>{formatPercent(row.percent)}</td>
                            <td>{formatRial(row.amount)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export function BuyerDetails({ buyerIndex, payouts }) {
    return (
        <>
            {buyerIndex === 0 ? (
                <p className="chain-detail-empty">
                    گره A بالاترین جایگاه زنجیره است و کسی بالاتر از آن نیست؛ پورسانتی
                    پرداخت نمی‌شود و کل حاشیهٔ سود باقی می‌ماند.
                </p>
            ) : (
                <PayoutTable rows={payouts.paidUplines} buyer />
            )}

            {payouts.unpaidLevels.length > 0 ? (
                <p className="chain-detail-platform">
                    سطوح پرداخت‌نشده: {formatNumber(payouts.unpaidLevels.length)}؛
                    پلتفرم {formatRial(payouts.platformKeptAmount)} را نگه می‌دارد.
                </p>
            ) : (
                <p className="chain-detail-platform">سطح پرداخت‌نشده‌ای وجود ندارد.</p>
            )}

            <dl className="chain-detail-totals">
                <div>
                    <dt>مجموع پورسانت</dt>
                    <dd>
                        {formatRial(payouts.totalCommissionAmount)}
                        <small>({formatPercent(payouts.totalCommissionPercent)})</small>
                    </dd>
                </div>
                <div>
                    <dt>سود باقی‌مانده</dt>
                    <dd>
                        {formatRial(payouts.remainingProfitAmount)}
                        <small>({formatPercent(payouts.remainingProfitPercent)})</small>
                    </dd>
                </div>
                <div className="chain-detail-safety">
                    <dt>مقایسه با حداقل سود</dt>
                    <dd className={payouts.isSafe ? 'is-safe' : 'is-unsafe'}>
                        {payouts.isSafe ? '✅ وضعیت امن' : '❌ کمتر از حداقل سود'}
                    </dd>
                </div>
            </dl>
        </>
    );
}

export function NodeEarningsDetails({ nodeIndex, earnings }) {
    if (earnings.rows.length === 0) {
        return (
            <p className="chain-detail-empty">
                گره {nodeLabel(nodeIndex)} پایین‌دستی ندارد و از خرید دیگری درآمدی
                دریافت نمی‌کند.
            </p>
        );
    }

    return (
        <>
            <PayoutTable rows={earnings.rows} />
            <p className="chain-detail-total">
                اگر هر گرهٔ پایین‌دستی یک‌بار خرید کند، درآمد گره{' '}
                {nodeLabel(nodeIndex)} در مجموع{' '}
                <strong>{formatRial(earnings.totalAmount)}</strong> خواهد بود.
            </p>
        </>
    );
}